import React from "react";
import { Link } from "react-router-dom";
//Components
import Dropdown from "./Dropdown";
//functions

const submenus = [
  {
    id: 6,
    name: "Inicio",
    description: "Inicio de la pagina",
    destination_uri: "/",
    position: 0,
    states: {
      id: 165,
      state: true,
    },
    menuItems: [],
  },
  {
    id: 8,
    name: "Quienes somos",
    description: "nosotros",
    destination_uri: "/quienes-somos",
    position: 1,
    states: {
      id: 167,
      state: true,
    },
    menuItems: [],
  },
  {
    id: 9,
    name: "Marco legal",
    description: "servicio al ciudadano",
    destination_uri: "/marco-legal",
    position: 2,
    states: {
      id: 168,
      state: true,
    },
    menuItems: [],
  },
  {
    id: 18,
    name: "Tipos de proyectos",
    description: "planesYProgramas",
    destination_uri: "/tipos-proyectos",
    position: 3,
    states: {
      id: 218,
      state: true,
    },
    menuItems: [],
  },
  {
    id: 19,
    name: "Presente su proyecto",
    description: "temas Ambientales",
    destination_uri: "/presente-su-proyecto",
    gif: "http://sgccontratos.car.gov.co:8082/getImgMenu/{name}?name=Temas_ambientales_WedJun15164918COT2022.gif",
    position: 4,
    states: {
      id: 219,
      state: true,
      description: "string",
      created_at: "2022-06-15T21:49:18.647+00:00",
      updated_at: "2022-06-15T21:49:18.647+00:00",
    },
    menuItems: [],
  },
  {
    id: 20,
    name: "Instrumentos de planeación",
    description: "instrumentos de planeación",
    destination_uri: "/",
    gif: "http://sgccontratos.car.gov.co:8082/getImgMenu/{name}?name=Transparencia_WedJun15164931COT2022.gif",
    position: 5,
    states: {
      id: 220,
      state: true,
      description: "string",
      created_at: "2022-06-15T21:49:31.473+00:00",
      updated_at: "2022-06-15T21:49:31.473+00:00",
    },
    menuItems: [],
  },
  {
    id: 20,
    name: "Formula CAR",
    description: "formula car",
    destination_uri: "/formula-car",
    gif: "http://sgccontratos.car.gov.co:8082/getImgMenu/{name}?name=Transparencia_WedJun15164931COT2022.gif",
    position: 5,
    states: {
      id: 220,
      state: true,
      description: "string",
      created_at: "2022-06-15T21:49:31.473+00:00",
      updated_at: "2022-06-15T21:49:31.473+00:00",
    },
    menuItems: [],
  },
];

const StickyMenu = () => {
  const menuItems = submenus.map((item, index) => {
    if (item.menuItems.length > 0) {
      return (
        <Dropdown
          key={index}
          name={item.name}
          items={item.menuItems}
          className="bg-acua text-light px-3 py-2 menu-item fw-bolder"
        />
      );
    } else {
      return (
        <div
          className="bg-acua px-3 py-2 menu-item text-center"
          key={index}
          style={styles.itemNormal}
        >
          <Link
            to={item.destination_uri}
            className="text-decoration-none text-light fw-bolder"
          >
            {item.name}
          </Link>
        </div>
      );
    }
  });

  return (
    <div
      className="bg-acua d-flex align-items-center justify-content-center  fs-responsive-s "
      style={styles.menu}
    >
      {menuItems}
    </div>
  );
};

export default StickyMenu;

const styles = {
  menu: { paddingRight: "10%", paddingLeft: "10%" },
};
